import { Component, ElementRef, EventEmitter, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-pagecontent',
  templateUrl: './pagecontent.component.html',
  styleUrls: ['./pagecontent.component.scss'],
})
export class PagecontentComponent implements OnInit {
  @Input() path;
  content;
  contentLoaded = new BehaviorSubject<boolean>(false);
  @ViewChild('contentContainer', { static: true }) contentContainer: ElementRef;

  constructor(
    private renderer: Renderer2,
    private dataSRV: DataService,
  ) {
  }

  ngOnInit() {
    this.dataSRV.pageContentArray$.subscribe((pages: any) => {
      const pathLower = this.path?.toLowerCase();
      if (
        pages &&
        pages.custom &&
        pages.custom.length > 0 &&
        pages.custom.find(p => p.path?.toLowerCase() === pathLower) &&
        this.dataSRV.existingRoutes.find(existingRoute => {
          if (existingRoute.endsWith('/')) {
            return pathLower.startsWith(existingRoute);
          } else {
            return pathLower === existingRoute;
          }
        })
      ) {
        const page = pages.custom.find(p => p.path?.toLowerCase() === pathLower);
        this.content = page?.content;
      } else {
        if (pages && pages.standard && pages.standard.length > 0 && pages.standard.find(p => p.path?.toLowerCase() === pathLower)) {
          const page = pages.standard.find(p => p.path?.toLowerCase() === pathLower);
          this.content = page?.content;
        }
      }
      this.injectContent();
      this.contentLoaded.next(!!this.content);
    });
  }

  injectContent() {
    if (this.contentContainer && this.content) {
      this.renderer.setProperty(this.contentContainer.nativeElement, 'innerHTML', this.content);
    }
  }


}

